import React from 'react';
import { translate } from 'react-i18next';
import {Card, CardText} from 'material-ui/Card';
import StandCreate from './StandCreate';
import {List, ListItem} from 'material-ui/List';
import FlatButton from 'material-ui/FlatButton';
import { Link } from 'react-router-dom';
import user from '../Auth/user';
import firebase from '../firebase';
import compose from '../compose';
import {Toolbar, ToolbarGroup, ToolbarTitle} from 'material-ui/Toolbar';
import LoadingIndicator from '../Navigation/LoadingIndicator';
import IconButton from 'material-ui/IconButton';
import Previous from 'material-ui/svg-icons/navigation/chevron-left';
import Next from 'material-ui/svg-icons/navigation/chevron-right';
import FirstPage from 'material-ui/svg-icons/navigation/first-page';
import LastPage from 'material-ui/svg-icons/navigation/last-page';
import Chip from 'material-ui/Chip';
import muiThemeable from 'material-ui/styles/muiThemeable';

class StandList extends React.Component {
  constructor(props) {
    super(props);
    this.initialState =  {
      stands: [],
      open: false,
      currentStand: null,
      loadingIndicator: 'flex',
      standsPerPage: 25,
      isFirstPage: true,
      isLastPage: false
    };
    this.state = {
      ...this.initialState
    };
  }
  componentDidMount = () => {
    const {user} = this.props;

    if(user.shopkeeperId) {
      this.getFirstStands(user.shopkeeperId);
    }
  }

  getFirstStands = (shopkeeperId) => {
    const {firebase} = this.props;

    firebase.database().ref(`shopkeepers/${shopkeeperId}/standsList/`)
      .orderByChild('name')
      .limitToFirst(this.state.standsPerPage)
      .once('value', (queryStands) => {
        this.updateFirstStands(queryStands);
        this.setState({loadingIndicator: 'none'});
      });
  }
  getLastStands = () => {
    const {firebase} = this.props;

    firebase.database().ref(`shopkeepers/${this.props.user.shopkeeperId}/standsList/`)
      .orderByChild('name')
      .limitToLast(this.state.standsPerPage)
      .once('value', this.updateStands);
    this.setState({isLastPage: true, isFirstPage: false});
  }
  getNextStands = () => {
    const {firebase} = this.props;

    firebase.database().ref(`shopkeepers/${this.props.user.shopkeeperId}/standsList/`)
      .orderByChild('name')
      .limitToFirst(this.state.standsPerPage)
      .startAt(this.state.stands[this.state.stands.length - 1].name + 'a')
      .once('value', this.updateStands);
    this.setState({isFirstPage: false});
  }
  getPreviousStands = () => {
    const {firebase} = this.props;

    firebase.database().ref(`shopkeepers/${this.props.user.shopkeeperId}/standsList/`)
      .orderByChild('name')
      .limitToLast(this.state.standsPerPage)
      .endAt(this.state.stands[0].name.slice(0, -1))
      .once('value', this.updateStands);
    this.setState({isLastPage: false});
  }

  updateFirstStands = (queryStands) => {
    const {firebase} = this.props;

    const stands = [];
    queryStands.forEach((data) => {
      const stand = {
        key: data.key,
        ...data.val()
      };
      stands.push(stand);
    });
    if (stands.length > 0) {
      this.setState({stands, firstStand: stands[0].key, isFirstPage: true});
    } else {
      this.setState({isFirstPage: true, isLastPage: true});
      return;
    }

    firebase.database().ref(`shopkeepers/${this.props.user.shopkeeperId}/standsList/`)
      .orderByChild('name')
      .limitToLast(1)
      .once('value', (stand) => {
        stand.forEach((lastStand) => {
          const isLastPage = (stands[stands.length - 1].key === lastStand.key);
          this.setState({isLastPage});
          this.setState({lastStand: lastStand.key});
        });
      });
    this.getTags(stands);
  }

  updateStands = (queryStands) => {
    const stands = [];
    queryStands.forEach((data) => {
      const stand = {
        key: data.key,
        ...data.val()
      };
      stands.push(stand);
    });
    this.setState({stands});
    if (stands[0].key === this.state.firstStand) {
      this.setState({isFirstPage: true});
    }
    if (stands[stands.length - 1].key === this.state.lastStand) {
      this.setState({isLastPage: true});
    }
    this.getTags(stands);
  }

  getTags = (stands) => {
    const {firebase} = this.props;
    stands.forEach((stand) => {
      firebase
        .database()
        .ref(`shopkeepers/${this.props.user.shopkeeperId}/stands/${stand.key}/standTag`)
        .once('value')
        .then((data) => {
          if (!data.exists()) {
            return;
          }
          stand.code = data.val().code;
          const currentStands = this.state.stands.slice();
          this.setState({stands: currentStands});
        });
    });
  }
  handleOpen = () => {
    this.setState({open: true});
  }
  handleEdit = (stand) => {
    this.setState({open: true, currentStand: stand});
  }
  handleClose = () => {
    this.setState({open: false, currentStand: null});
  }
  render() {
    const {t} = this.props;
    const stands =
    this.state.stands.map((stand) => (
      <ListItem key={stand.key}
        primaryText={stand.name}
        secondaryText={stand.description}
        containerElement={<Link to={`/stands/${stand.key}`} />}
        rightAvatar={stand.code ?
          <Chip backgroundColor={this.props.muiTheme.palette.primary2Color} labelColor='white'>
            {stand.code}
          </Chip> : null}>
      </ListItem>
    ));

    return (
          <Card className='cardStyle'>
            <Toolbar>
              <ToolbarGroup>
                <ToolbarTitle text={t('stand.stands')} />
              </ToolbarGroup>
              <ToolbarGroup lastChild={true}>
                <FlatButton label={t('stand.create')} primary={true} onTouchTap={this.handleOpen}/>
              </ToolbarGroup>
            </Toolbar>
            <CardText style={{textAlign: 'left', position: 'relative'}}>
              <List>
                {stands}
              </List>
              <div>
                <IconButton
                  onTouchTap={() => this.getFirstStands(this.props.user.shopkeeperId)}
                  disabled={(this.state.isFirstPage)}>
                  <FirstPage />
                </IconButton>
                <IconButton
                  onTouchTap={this.getPreviousStands}
                  disabled={(this.state.isFirstPage)}>
                  <Previous />
                </IconButton>
                <IconButton
                  onTouchTap={this.getNextStands}
                  disabled={(this.state.isLastPage)}>
                  <Next />
                </IconButton>
                <IconButton
                  onTouchTap={this.getLastStands}
                  disabled={(this.state.isLastPage)}>
                  <LastPage />
                </IconButton>
              </div>
              <LoadingIndicator display={this.state.loadingIndicator} />
            </CardText>
            <StandCreate handleClose={this.handleClose} open={this.state.open} currentStand={this.state.currentStand}/>
          </Card>
    );
  }
}

const enhance = compose(muiThemeable(), translate(), firebase, user);

export default enhance(StandList);



// WEBPACK FOOTER //
// ./src/Stand/StandList.js